import React from 'react';

import OffRampsContainer from '../containers/OffRamps';

const OffRampPage = () => <OffRampsContainer />;

export default OffRampPage;
